import React, { FC } from "react";
import { type TimelineStepProps, TimelineStep } from "./TimelineStep";

export interface TimelineProps {
  steps: TimelineStepProps[];
  className?: string;
}

export const Timeline: FC<TimelineProps> = ({
  steps,
  className,
}) => {
  return (
    <div className={`w-full max-w-2xl mx-auto ${className}`}>
        <div className="space-y-0">
          {steps.map((step, index) => (
            <TimelineStep
              key={`${index}-${step.title}`}
              {...step}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>
    </div>
  );
};

export default Timeline; 
